import { FunctionComponent } from 'react';
import { useMap } from 'react-leaflet';
import { L3ServiceLocationViewModel } from '../../model';

interface Props {
  locations: L3ServiceLocationViewModel[];
}

export const TopologySearchHandler: FunctionComponent<Props> = ({ locations }: Props) => {
  const map = useMap();
  if (locations.length === 1) {
    map.setView([locations[0].coordinates.latitude, locations[0].coordinates.longitude])
  }
  return <></>;
};